/**
 * This code is bad and needs to die
 */
export default class CustomerData {
  // #isPpa = 0;
  // #ppwRate = 0;
  // #systemSize = 0;
  // #battery10 = 0;
  // #battery10Amount = 0;
  // #systemCost = 0;
  // #downPayment = 0;
  // #sameDay = 0;
  // #sameDayAmount = 0;
  // #preferredUtility = 0;
  // #preferredUtilityAmount = 0;
  // #referral = 0;
  // #referralAmount = 0;
  // #custUtility = 0;
  // #rebate = 0;

  constructor(
    loan,
    systemSize,
    battery10,
    battery10Amount,
    expansionPack,
    expansionPackAmount,
    systemCost,
    downPayment,
    sameDay,
    sameDayAmount,
    preferredUtility,
    preferredUtilityAmount,
    referral,
    referralAmount,
    custUtility,
    rebate,
    homeEnergyTotal,
    stateTax,
    recValue,
    powerWall,
    totalProduction,
    state,
    utilityLseId,
    msp,
    ppaProducts,
    dealerFee
  ) {
    this._loan = loan;
    this._isPpa = loan.isPpa;
    this._ppwRate = loan.ppwRate;
    this._itc = loan.itc;
    this._systemSize = systemSize;
    this._battery10 = battery10;
    this._battery10Amount = battery10Amount;
    this._expansionPack = expansionPack;
    this._expansionPackAmount = expansionPackAmount;
    this._systemCost = systemCost;
    this._downPayment = downPayment;
    this._sameDay = sameDay;
    this._sameDayAmount = sameDayAmount;
    this._preferredUtility = preferredUtility;
    this._preferredUtilityAmount = preferredUtilityAmount;
    this._referral = referral;
    this._referralAmount = referralAmount;
    this._custUtility = custUtility;
    this._rebate = rebate;
    this._loanAmount = this.calculateLoanAmount();
    this._netCost = this.calculateNetCost();
    this._discounts = 0;
    this._homeEnergyTotal = homeEnergyTotal;
    this._stateTax = stateTax;
    this._recValue = recValue;
    this._powerWall = powerWall;
    this._totalProduction = totalProduction;
    this._state = state;
    this._utilityLseId = utilityLseId;
    this._msp = msp;
    this._ppaProducts = ppaProducts;
    this._dealerFee = dealerFee;
  }

  calculateNetCost(loanAmount = 0, itc = -1) {
    if (!loanAmount) {
      loanAmount = this.loanAmount;
    }
    if (itc < 0) {
      itc = this.itc;
    }
    let newNetCost =
      +loanAmount +
      +this.downPayment -
      (+loanAmount + +this.downPayment - this.homeEnergyTotal) * itc -
      this.stateTax -
      (this.recValue?.afterEnergy || 0);

    if (
      this.custUtility === "Austin Energy" ||
      this.custUtility === "Ameren Illinois" ||
      this.custUtility === "Commonwealth Edison (ComEd)" ||
      this.powerWall
    ) {
      newNetCost =
        +loanAmount -
        +this.rebate +
        +this.downPayment -
        (+loanAmount + +this.downPayment - this.homeEnergyTotal) * itc -
        this.stateTax -
        (this.recValue?.afterEnergy || 0);
    }
    return newNetCost;
  }

  calculateDiscounts(sameDayTotal, referralTotal, preferredUtilityTotal) {
    this._discounts =
      sameDayTotal + referralTotal + this.systemSize * preferredUtilityTotal;
    return this.discounts;
  }

  calculateLoanAmount(isPpa = 0, ppaRate = 0) {
    if (isPpa === 1) {
      return (
        +ppaRate * this.systemSize +
        (+this.battery10 > 0 ? +this.battery10Amount : 0)
      );
    }

    let sameDayTotal = this.sameDay === 1 ? +this.sameDayAmount : 0;
    let preferredUtitityTotal =
      this.preferredUtility === 1 ? +this.preferredUtilityAmount : 0;
    let referralTotal = this.referral === 1 ? +this.referralAmount : 0;

    this.calculateDiscounts(sameDayTotal, referralTotal, preferredUtitityTotal);

    if (
      this.custUtility === "Austin Energy" ||
      this.custUtility === "Salem Electric" ||
      this.custUtility === "Fort Collins Utilities (FCU)" ||
      this.custUtility.includes("Xcel Energy") ||
      this.custUtility === "Ameren Illinois" ||
      this.custUtility === "Commonwealth Edison (ComEd)"
    ) {
      return Math.ceil(
        this.systemCost -
          this.downPayment -
          sameDayTotal -
          referralTotal -
          this.systemSize * preferredUtitityTotal
      );
    }

    return Math.ceil(
      this.systemCost -
        this.rebate -
        this.downPayment -
        sameDayTotal -
        referralTotal -
        this.systemSize * preferredUtitityTotal
    );
  }

  calculateLoanAmountPpa(isPpa, ppaRate) {
    let isPpa_ = this.isPpa;
    this._isPpa = isPpa;
    let loanAmount = this.calculateLoanAmount(ppaRate);
    this._isPpa = isPpa_;
    return loanAmount;
  }

  get loan() {
    return this._loan;
  }

  get isPpa() {
    return this._isPpa;
  }

  get ppwRate() {
    return this._ppwRate;
  }

  get systemSize() {
    return this._systemSize;
  }

  get battery10() {
    return this._battery10;
  }

  get battery10Amount() {
    let total = 0;
    const additionalBatteryAmount =
      (this._state === "Illinois" || this._state === "Texas"
        ? this._battery10Amount
        : 12500) / +this._dealerFee;
    total +=
      this._battery10Amount + additionalBatteryAmount * (this.battery10 - 11);

    if (this._expansionPack) {
      total += this._expansionPackAmount * this._expansionPack;
    }
    return total;
  }

  get expansionPack() {
    return this._expansionPack;
  }

  get expansionPackAmount() {
    return this._expansionPackAmount;
  }

  get systemCost() {
    return this._systemCost;
  }

  get downPayment() {
    return this._downPayment;
  }

  get sameDay() {
    return this._sameDay;
  }

  get sameDayAmount() {
    return this._sameDayAmount;
  }

  get preferredUtility() {
    return this._preferredUtility;
  }

  get preferredUtilityAmount() {
    return this._preferredUtilityAmount;
  }

  get referral() {
    return this._referral;
  }

  get referralAmount() {
    return this._referralAmount;
  }

  get custUtility() {
    return this._custUtility;
  }

  get rebate() {
    return this._rebate;
  }

  get loanAmount() {
    return this._loanAmount;
  }

  get netCost() {
    return this._netCost;
  }

  get discounts() {
    return this._discounts;
  }

  get homeEnergyTotal() {
    return this._homeEnergyTotal;
  }

  get stateTax() {
    return this._stateTax;
  }

  get recValue() {
    return this._recValue;
  }

  get itc() {
    return this._itc;
  }

  get powerWall() {
    return this._powerWall;
  }

  get totalProduction() {
    return this._totalProduction;
  }

  get state() {
    return this._state;
  }

  get utilityLseId() {
    return this._utilityLseId;
  }

  get msp() {
    return this._msp;
  }

  get ppaProducts() {
    return this._ppaProducts;
  }
}
